import { UserSettingsKey, SetUserSettingsResponse } from "./types";
import { dashboardBFF } from "../axios-instances";
import { getServices } from "src/logs";

const { logger } = getServices();

export const setUserSetting = async (
  key: UserSettingsKey,
  value: string | boolean
): Promise<SetUserSettingsResponse> => {
  try {
    const url = `/api/user-settings/${key}`;

    const response = await dashboardBFF.put(url, {
      value: value
    });
    if (response.status === 204) {
      const err = new Error("No content, http status code: 204");
      throw err;
    }
    return response.data as SetUserSettingsResponse;
  } catch (error) {
    const err = error as Error;
    if (!err.message.includes("204")) {
      logger.logError({
        message: "setUserSetting - Exception",
        properties: {
          name: err.name,
          message: err.message,
          stack: err.stack || "unknown stack",
          cause: String(err.cause ?? "unknown cause")
        }
      });
    }
    throw error;
  }
};

